module.exports = __webpack_public_path__ + "img/botuo2.3dbc032d.png";